import { render, staticRenderFns } from "./DialogResetPassword.vue?vue&type=template&id=de105c48&scoped=true&"
import script from "./DialogResetPassword.vue?vue&type=script&lang=js&"
export * from "./DialogResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./DialogResetPassword.vue?vue&type=style&index=0&id=de105c48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de105c48",
  null
  
)

export default component.exports